import Vue from "vue";

import AppLoading from "@/components/utils/AppLoading.vue";

let instance = null;

function ensureInstance() {
    if (!instance) {
        const LoadingConstructor = Vue.extend(AppLoading);
        instance = new LoadingConstructor();
        instance.$mount();
        document.body.appendChild(instance.$el);
    }
    return instance;
}

export const loading = {
    show() {
        ensureInstance().visible = true;
    },
    hide() {
        if (instance) instance.visible = false;
    },
    async wrap(fn) {
        this.show();
        try {
            return await fn();
        } finally {
            this.hide();
        }
    }
};

export default {
    install(VueGlobal) {
        VueGlobal.prototype.$loading = loading;
    }
};
